// This will contain the functions used tool-side to modify the current state

import { Operation, Persistence } from './persistence';
import { Workflow } from './process/workflow';

export class State {
    public static getWorkflow(): Workflow | null {
        // TODO: untested, please make sure I work!
        // When a tool calls me, I should return the whatever workflow ATBase created!
        const workflowId = Persistence.getCurrent(Operation.WORKFLOW);
        if (!workflowId) return null;
        const data = Persistence.getById(Operation.WORKFLOW, workflowId);
        return Workflow.fromJSON(data);
    }
}
